import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "@/index.css";
import App from "@/App";
import { iniciarChequeoActualizaciones } from "@/utils/actualizacionApp";
import { instalarEnlacesFirmados } from "@/utils/enlacesFirmados";

instalarEnlacesFirmados();

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
    },
  },
});

if ("serviceWorker" in navigator) {
  window.addEventListener("load", () => {
    navigator.serviceWorker.register("/sw.js")
      .then((reg) => {
        iniciarChequeoActualizaciones(reg);
        // Guardar en caché todos los chunks publicados (pantallas disponibles aunque la red sea lenta o no haya señal)
        const pedirPrecarga = () => navigator.serviceWorker.controller?.postMessage('freshen:precargar-build');
        setTimeout(pedirPrecarga, 6000);
        window.addEventListener('online', () => setTimeout(pedirPrecarga, 3000));
      })
      .catch(() => iniciarChequeoActualizaciones(null));
  });
} else {
  window.addEventListener("load", () => iniciarChequeoActualizaciones(null));
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </React.StrictMode>,
);
